import {LorenGeofencingShape} from '../interfaces/loren-geofencing-shape.interface';
import {LorenGeofencingType} from '../enums/loren-geofencing-type.enum';

export const LorenGeofencingShapes: LorenGeofencingShape[] = [
    {
        img: '/assets/icons/polygon-512x512.png',
        label: 'geofencing.polygon',
        type: LorenGeofencingType.POLYGON
    },
    {
        img: '/assets/icons/circle-512x512.png',
        label: 'geofencing.circle',
        type: LorenGeofencingType.CIRCLE
    },
    {
        img: '/assets/icons/rectangle-512x512.png',
        label: 'geofencing.rectangle',
        type: LorenGeofencingType.RECTANGLE
    }
];
